import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Nav";
import Footer from "../components/Footer";
import { CartContext } from "../context/CartContext";
import { doc, getDoc, collection, getDocs, query, limit } from "firebase/firestore";
import { db } from "../firebase";
import toast, { Toaster } from "react-hot-toast";

const ProductDetail = () => {
  const { id } = useParams();
  const { addToCart } = useContext(CartContext);
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const BROWN = "#5b3a29";
  const OLIVE = "#8a8f3a";
  const WHITE = "#ffffff";

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        // جلب المنتج الحالي
        const docRef = doc(db, "products", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const prodData = { id: docSnap.id, ...docSnap.data() };
          setProduct(prodData);

          // جلب أحدث 5 منتجات واستبعاد المنتج الحالي
          const q = query(collection(db, "products"), limit(6));
          const snapshot = await getDocs(q);
          const similar = snapshot.docs
            .map(doc => ({ id: doc.id, ...doc.data() }))
            .filter(p => p.id !== prodData.id);
          setSimilarProducts(similar);
        } else {
          console.log("No such product!");
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  const handleAddToCart = (prod) => {
    addToCart({ ...prod, quantity: 1 });
    toast.success(`${prod.name} تم إضافته للسلة! 🛒`);
  };

  if (loading) {
    return (
      <div style={{ minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        Loading...
      </div>
    );
  }

  if (!product) {
    return (
      <div style={{ minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "20px", color: "red" }}>
        Product not found
      </div>
    );
  }

  const sectionStyle = { background: "#f5f0ea", padding: "80px 20px", fontFamily: "Inter, system-ui, sans-serif" };
  const titleStyle = { textAlign: "center", color: BROWN, fontSize: 36, fontWeight: 700, marginBottom: 40 };
  const cardStyle = { borderRadius: 12, overflow: "hidden", boxShadow: "0 4px 14px rgba(0,0,0,0.08)", transition: "transform 0.3s ease", background: "#fff", border: `1px solid ${OLIVE}33` };
  const imageStyle = { width: "100%", objectFit: "cover" };
  const infoStyle = { padding: 16, textAlign: "center" };
  const nameStyle = { fontSize: 18, fontWeight: 600, color: BROWN, marginBottom: 8 };
  const priceStyle = { fontSize: 16, color: OLIVE, fontWeight: 700, marginBottom: 12 };
  const buttonStyle = { background: BROWN, color: WHITE, border: "none", padding: "10px 18px", borderRadius: 8, fontWeight: 600, cursor: "pointer", transition: "background 0.3s ease" };
  const buttonContainer = { display: "flex", justifyContent: "center", gap: "10px" };

  return (
    <>
      <Navbar />
      <Toaster position="top-right" />
      <div style={{ minHeight: "80vh", padding: "50px 20px", backgroundColor: "#f5f0ea" }}>
        {/* المنتج الحالي */}
        <div style={{ maxWidth: "1000px", margin: "0 auto", display: "flex", flexWrap: "wrap", gap: "40px" }}>
          <div style={{ flex: "1", minWidth: "300px", display: "flex", justifyContent: "center" }}>
            <img src={product.imageUrl} alt={product.name} style={{ ...imageStyle, maxHeight: "450px", borderRadius: "15px", boxShadow: "0 8px 20px rgba(0,0,0,0.1)" }} />
          </div>
          <div style={{ flex: "1", minWidth: "300px" }}>
            <h1 style={{ fontSize: "32px", color: BROWN, marginBottom: "20px" }}>{product.name}</h1>
            <p style={{ fontSize: "24px", fontWeight: "700", color: OLIVE, marginBottom: "20px" }}>{product.price.toLocaleString()} EGP</p>
            <p style={{ fontSize: "16px", marginBottom: "30px", color: BROWN }}>{product.description || "No description available for this product."}</p>
            <button
              onClick={() => handleAddToCart(product)}
              style={buttonStyle}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#d4af37")}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = BROWN)}
            >
              Add to Cart
            </button>
          </div>
        </div>

        {/* المنتجات المشابهة بنفس ستايل FeaturedProducts */}
        {similarProducts.length > 0 && (
          <section style={sectionStyle}>
            <h2 style={titleStyle}>You may also like</h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 24, maxWidth: 1200, margin: "auto" }}>
              {similarProducts.map(p => (
                <div key={p.id} style={cardStyle} className="product-card">
                  <img src={p.imageUrl} alt={p.name} style={{ ...imageStyle, height: "240px" }} />
                  <div style={infoStyle}>
                    <h3 style={nameStyle}>{p.name}</h3>
                    <p style={priceStyle}>{p.price} EGP</p>
                    <div style={buttonContainer}>
                      <button style={buttonStyle} onClick={() => handleAddToCart(p)}>Add to Cart</button>
                      <button style={{ ...buttonStyle, background: OLIVE }} onClick={() => navigate(`/product/${p.id}`)}>View Product</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}
      </div>
      <Footer />
    </>
  );
};

export default ProductDetail;
